import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import {createRoot} from 'react-dom/client';
import { AnimatePresence, motion } from "framer-motion"
import 'index.css'

import Home from "Home.js"
import Experience from "Experience.js"

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait" exitBeforeEnter>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<SoftAnimate><Home /></SoftAnimate>} />
        <Route path="/experience" element={<SoftAnimate><Experience /></SoftAnimate>} />
      </Routes>
    </AnimatePresence>
  )
}
function SoftAnimate({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0}}
      transition={{ 
        duration: 0.4,
        delay: 0.2,
      }}
    >
      {children}
    </motion.div>
  )
}

function App() {
  return (
    <div>
      <style>
        {`
          /* Apply custom cursor globally and for all states */
          html, body, *, button, a, input,
          .disabled, a:disabled, input:disabled {
            cursor: url('/yellowcircle.svg'), auto;
          }

          button:hover, a:hover, input:hover, .hover:hover, h1:hover, h2:hover, h3:hover, img:hover, p:hover {
            cursor: url('/whitecircle.svg'), auto;
          }

          button:focus, a:focus, input:focus, .focus:focus, h1:focus, h2:focus, h3:focus, img:focus, p:focus {
            cursor: url('/yellowcircle.svg'), auto;
          }
        `}
      </style>
      <BrowserRouter>
        <AnimatedRoutes />
      </BrowserRouter>
    </div>
  );
}
root.render(<App />);
export default App;